import { EditIcon, KeyIcon, ProfileIcon } from "assets";
import { SmallScreenModel } from "components";
import HandleEmailChange from "modules/auth/users/pages/manage_user/HandleEmailChange";
import HandleMobileNoChange from "modules/auth/users/pages/manage_user/HandleMobileNoChange";
import HandleNameChange from "modules/auth/users/pages/manage_user/HandleNameChange";
import HandlePasswordChange from "modules/auth/users/pages/manage_user/HandlePasswordUpdate";
import { UserProps } from "modules/auth/users/store/actionType";
import React, { useState } from "react";
interface UserProfileProps {
  userData: UserProps;
}
const UserProfile: React.FC<UserProfileProps> = ({ userData }) => {
  const [nameChangeModel,setNameChangeModel] = useState(false)
  const [emailChangeModel,setEmailChangeModel] = useState(false)
  const [mobileNoChangeModel,setMobileNoChangeModel] = useState(false)
  const [passwordChangeModel,setPasswordChangeModel] = useState(false)
  return (
    <>
      <div>
        <section id="User">
          <h2 className="text-2xl font-semibold mt-6 px-6">User Profile</h2>
          <div className="m-6 p-6 bg-primary-500 rounded-lg shadow-md text-white">
            <div className="flex items-center gap-4">
              <h1 className="w-20 h-20 rounded-full p-3 bg-primary-50 flex justify-center items-center text-primary-700 font-bold text-5xl">
                {userData?.name?.toUpperCase().charAt(0)}
              </h1>
              <div className="flex flex-col">
                <p className="text-xl font-semibold flex items-center">
                  {" "}
                  {userData.name}{" "}
                  <span onClick={()=>setNameChangeModel(true)}> 
                    <EditIcon className="size-4 ml-2 cursor-pointer" />
                  </span>
                </p>
                <p className="text-lg font-light"> {"Admin | content"}</p>
              </div>
            </div>
          </div>
        </section>
        <section id="User">
          <div className="m-6 p-6 bg-primary-500 rounded-lg shadow-md text-white">
            <h2 className="text-2xl font-semibold mb-4 text-white">
              Personal Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div onClick={()=>setEmailChangeModel(true)} className="cursor-pointer">
                <span className="text-sm font-light">Email</span>
                <span className="text-lg font-medium flex items-center gap-2">
                  {userData.email} <EditIcon />
                </span>
              </div>
              <div onClick={()=>setMobileNoChangeModel(true)} className="cursor-pointer">
                <span className="text-sm font-light">Phone</span>
                <span className="text-lg font-medium flex items-center gap-2">
                  {userData.mobile_no} <EditIcon />
                </span>
              </div>
              <div>
                <span className="text-sm font-light">Status</span>
                <span className="text-lg font-medium flex items-center gap-2">
                  {userData.status} 
                </span>
              </div>
              <div>
                <button onClick={()=>setPasswordChangeModel(true)} className="flex items-center gap-2 text-lg font-medium hover:text-primary-300">
                 Change Password <KeyIcon />
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <SmallScreenModel showModal={nameChangeModel} setShowModal={setNameChangeModel}>
        <HandleNameChange userData={userData} closeModal={setNameChangeModel}/>
      </SmallScreenModel>
      <SmallScreenModel showModal={emailChangeModel} setShowModal={setEmailChangeModel}>
        <HandleEmailChange userData={userData} closeModal={setEmailChangeModel}/>
      </SmallScreenModel>
      <SmallScreenModel showModal={mobileNoChangeModel} setShowModal={setMobileNoChangeModel}>
        <HandleMobileNoChange userData={userData} closeModal={setMobileNoChangeModel}/>
      </SmallScreenModel>
      <SmallScreenModel showModal={passwordChangeModel} setShowModal={setPasswordChangeModel}>
        <HandlePasswordChange userData={userData} closeModal={setPasswordChangeModel}/>
      </SmallScreenModel>
    </>
  );
};

export default UserProfile;
